import React from "react";

const VisionMissionValues = () => {
  return (
    <div className="container-fluid bg-light py-5">
      <div className="container py-5">
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
          <h5 className="sub-title" style={{ color: "#A71717" }}>Our Core Principles</h5>
          <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>Vision, Mission & Values</h1>
        </div>

        <div className="row g-4">
          {/* Vision */}
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
            <div className="text-center p-4 bg-white h-100 shadow-sm rounded">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-4"
                style={{ width: "80px", height: "80px" }}
              >
                <i className="fas fa-eye fa-3x" style={{ color: "#A71717" }}></i>
              </div>
              <h4 style={{ color: "#A71717" }}>Our Vision</h4>
              <p className="text-muted">
                To become the leading effective business solutions provider in Africa.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
            <div className="text-center p-4 bg-white h-100 shadow-sm rounded">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-4"
                style={{ width: "80px", height: "80px" }}
              >
                <i className="fas fa-bullseye fa-3x" style={{ color: "#A71717" }}></i>
              </div>
              <h4 style={{ color: "#A71717" }}>Our Mission</h4>
              <p className="text-muted">
                To revolutionize business operations across Africa's commercial landscape by utilizing
                state-of-the-art ICT and software, supported by top-notch local expertise that aligns with
                international standards.
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="500">
            <div className="text-center p-4 bg-white h-100 shadow-sm rounded">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-4"
                style={{ width: "80px", height: "80px" }}
              >
                <i className="fas fa-heart fa-3x" style={{ color: "#A71717" }}></i>
              </div>
              <h4 style={{ color: "#A71717" }}>Our Values</h4>
              <ul className="list-unstyled text-start d-inline-block text-muted">
                {[
                  "Customer-Centric",
                  "Improvement & Innovation",
                  "Social Responsibility",
                  "Reliability",
                ].map((value, i) => (
                  <li key={i} className="mb-2">
                    <i className="fas fa-check me-2" style={{ color: "#FFAA00" }}></i>
                    {value}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMissionValues;
